import React from "react";
import { Link } from "react-router-dom";
import back from "../Assets/back.png"
import "../pages/Proyect.css";

const BackButton = () => {
  return (
    <Link to="/portfolio" className="back-link">

   <div class="arrow-right">&#10140;</div>
    </Link>
  );
};

export default BackButton;

